var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneHangup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 12c-4.054 0-7.859.827-9.76 2.672-.859.837-1.29 1.846-1.233 3.063.036.737.27 1.391.71 1.818.329.327.787.51 1.32.427l3.47-.572c.523-.082.888-.237 1.122-.473.308-.29.404-.727.404-1.3v-.918c0-.145.063-.254.159-.345.092-.11.233-.155.335-.182.638-.145 1.928-.282 3.473-.282 1.541 0 2.822.11 3.469.291a.874.874 0 0 1 .326.173c.084.09.141.191.15.336l.009.927c.012.573.105 1.01.404 1.3.243.236.608.391 1.132.473l3.424.563c.551.091 1.018-.1 1.384-.445.44-.418.682-1.063.703-1.8.027-1.227-.461-2.236-1.302-3.054-1.898-1.845-5.65-2.672-9.7-2.672z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneHangup);
export default __webpack_public_path__ + "static/media/Phone_Hangup.7c344247e3fa3694b6bc32cee65c2e25.svg";
export { ForwardRef as ReactComponent };